<template lang="html">
  <div>
    <div class="top-bar">
      <div class="city-trigger"><i class="icon"></i>{{ cityName }}</div>
      <div class="change-city" @click="switchCity">
        切换<i class="arrow"></i>
      </div>
    </div>
    <loadData
      viewName="groupList"
      :fetchData="list"
      :fetchMethod="fetchGroupList"
      :controlPage="changePage"
      :page="pageIndex"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
      :otherParams="{ errText: '暂无拼团活动', errImg: img }"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loadData from '@/components/loadMore'
import countDown from '@/components/common/countDown'
import changePrivinceCodeToCityCode from '@/plugins/changeCityCode'
import groupList from '@/components/groupBuy/groupList'
import isIOS from '@/plugins/isIOS'

export default {
  data() {
    return {
      list: [],
      pageIndex: 1,
      pageSize: 10,
      firstFetch: true,
      hasErr: false,
      isBottom: false,
      cityCode: -1,
      cityName: '全国',
      img: require('../../assets/images/empty1.png'),
      isIOS: true
    }
  },
  components: {
    countDown,
    groupList,
    loadData
  },
  computed: {
    shareRemark() {
      // https://doc.weixin.qq.com/sheet/e3_AHcAFgYQAOQ5JzaHs1ySymwTlnHNW
      // toolType
      // 401	服务分享赚
      // 402	心愿单
      // 403	代客下单
      // --------------
      // contentType\contentId
      // 201	服务商祥	SPUID
      // 202	服务拼团商祥	SKUID
      // 203	服务景区详情	SPUID
      // 204	服务频道页	CHANNEL_ID
      // 205	服务天天特价频道页
      // 206	服务晒图有奖
      // 207	服务店铺	BUSINESSID
      // 208	服务人格化主页	WORKERID
      const remark = {
        // toolType,
        // toolCode,
        url: encodeURIComponent(location.href),
        contentType: 202,
        contentId: this.skuId || ''
        // storeCode,
        // groupId,
        // phoneNumber
      }
      return remark
    }
  },
  methods: {
    async getCityCode() {
      const city = (this.$$cookie('city_service') || '').split('_')[0]
      const groupcity = this.$$cookie('groupcity') || ''
      // 其次路由上面有没有groupcity，看用户是否是打开他人分享，展示分享人的所在城市
      let shareGroupCity
      const params = location.search.slice(1).split('&')
      params.forEach(item => {
        if (item.indexOf('groupcity') === 0) {
          shareGroupCity = item.slice(item.indexOf('=') + 1)
        }
      })
      if (city) {
        this.cityCode = city
      } else if (shareGroupCity) {
        this.cityCode = shareGroupCity
      } else {
        // 如果用户从育儿首页进来，那这个页面默认保持和首页相同城市，用cookie里面的city即可，如果cookie里面没有的话，即展示默认的全国
        this.cityCode = groupcity || city || -1
      }
      const res = await this.$store.dispatch('getNameById', {
        addressId: this.cityCode
      })
      if (res && res.NAME) this.cityName = res.NAME.replace('市', '')
      this.cityCode = changePrivinceCodeToCityCode(this.cityCode)
    },
    async fetchGroupList() {
      if (this.page === 1) {
        this.list.length = 0
        this.list = []
      }
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        cityCode: this.cityCode,
        serviceId: 40
      }
      const list = await this.$store.dispatch('fetchGroupList', params)
      this.list.push(...(list || []))
      this.firstFetch = false
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    },
    confirmShareInfo() {
      const shareInfo = {
        title: '服务拼团限时抢，育儿服务助您轻松育儿',
        desc: '孩子王育儿服务平台为您提供高品质超便捷的专业育儿服务',
        remark: JSON.stringify(this.shareRemark),
        imgUrl:
          'https://cmspic-10004025.image.myqcloud.com/433b8770-f706-11e9-8988-ad8f9d33b67d_size_840x504',
        link: `https:${this.$$hostname(
          'life'
        )}/v/groupBuy/groupList?groupcity=${
          this.cityCode
        }&cmd=share&sharetype=0&refresh=no`
      }
      window.getAppShareInfo = () => shareInfo
    },
    switchCity() {
      // 上面为正式版
      location.href = `https://life.cekid.com/h5/city-choose?referer=${encodeURIComponent(
        'https://life.cekid.com/v/groupBuy/groupList'
      )}`
      // location.href = `https://life.cekid.com/h5/city-choose?referer=${encodeURIComponent('http://dev.cekid.com:8088/v/groupBuy/groupList')}`
    }
  },
  async created() {
    try {
      this.$$title('育儿服务拼团')
      this.isIOS = isIOS
      await this.getCityCode().then(() => {
        this.fetchGroupList()
      })
      // 获取团列表
      // 确定分享信息
      this.confirmShareInfo()
      window.kwapp.allowRefreshOrShare(false, true)
    } catch (e) {
      if (window.kwapp && window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.allowRefreshOrShare(false, true)
        })
      }
      this.$$error(e, this)
    }
    this.$$loading(false)
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.top-bar {
  height: rem(100px);
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 rem(24px);
  .city-trigger {
    flex: 1;
    color: #121212;
    font-size: rem(30px);
    word-break: keep-all;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .icon {
      display: inline-block;
      margin: 0 rem(10px) 0 rem(4px);
      width: rem(18px);
      height: rem(24px);
      box-sizing: border-box;
      background: url('//cmspic-10004025.image.myqcloud.com/90d731f0-2258-11ea-a5e7-dbd8a7023663_size_27x36')
        no-repeat center center;
      background-size: contain;
    }
  }
  .change-city {
    font-size: rem(28px);
    color: #999999;
    line-height: rem(32px);
    .arrow {
      display: inline-block;
      margin: rem(4px) 0 0 rem(10px);
      width: rem(14px);
      height: rem(22px);
      box-sizing: border-box;
      background: url('//cmspic-10004025.image.myqcloud.com/1f5f8990-2259-11ea-a5e7-dbd8a7023663_size_21x33')
        no-repeat center center;
      background-size: contain;
    }
  }
}
</style>
